// extracted by mini-css-extract-plugin
export var bodyRow = "_h5-d";
export var cardColumns = "_h5-e";
export var ellipsesOverflow = "_h5-2";
export var flatBottomCorners = "_h5-3";
export var flatTopCorners = "_h5-4";
export var headerActionsDropdown = "_h5-f";
export var headerBottomRow = "_h5-c";
export var headerTopRow = "_h5-b";
export var orderDetailsWrapper = "_h5-0";
export var orderInfoContainer = "_h5-1";
export var productDetails = "_h5-9";
export var productImage = "_h5-5";
export var responsiveTable = "_h5-8";
export var shipmentContainer = "_h5-a";
export var tableBottomLeft = "_h5-6";
export var tableBottomRight = "_h5-7";
export var trackingLink = "_h5-g";